import {useEffect, useState} from "react";
import SideMenu from "../SideMenu";
import { Link } from "react-router-dom";
import Permission from "../RoleManagement/Permission";
import Suppliers from "../Report/Suppliers";
export default function SupplierTspReport(){
    return(
        <>
        
        <div>
        <Suppliers />
        </div>
       {/*<main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2">Suppliers</h1>
        </div>
          <div className='buttons-left'>
              <Permission access={"/tspsupplierreport"}>
                <Link to="/tspsupplierreport"><button className='btn btn-primary btn-add'> <i></i>TSP
               </button></Link>
              </Permission>
              <Permission access={"/suppliers"}>
                <Link to="/suppliers"><button className='btn btn-primary btn-add'> <i></i>Supliers</button></Link>
              </Permission>
            </div>
            </main>*/}
            </>
    )


};
